import type {PayloadAction, WritableDraft} from '@reduxjs/toolkit';
import type {MetadataEditState, WorkV4} from '../types';
import {
  assertMetadata,
  replaceWork,
  updateEditStatusOnEdit,
  updateWorkExportProps,
} from '../functions';
import type {MetadataEditAction_WorkEdited} from '../metadataEditActionTypes';

export const metadataEditWorkEditedReducer = (
  state: WritableDraft<MetadataEditState>,
  action: PayloadAction<WorkV4>,
) => {
  const originalAction: MetadataEditAction_WorkEdited = {
    type: 'METADATAEDIT_WORK_EDITED',
    payload: action.payload,
  };

  const savedMetadata = assertMetadata(
    state.savedMetadata,
    originalAction,
    'saved',
  );
  const metadata = assertMetadata(state.metadata, originalAction, 'edit');
  const newWork = {...metadata.work, ...action.payload};

  state.metadata = replaceWork(newWork, metadata);
  state.editStatuses = updateEditStatusOnEdit(
    savedMetadata.work,
    newWork,
    state.editStatuses,
  );
  state.exports = updateWorkExportProps(newWork, state.exports);
};
